import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Styles from "./ViewBillList.module.css";
import cancelIcon from "../../../Assets/cross.png";
import Profile from "../../../Assets/user_img.png";
import mail from "../../../Assets/email.png";
import phone from "../../../Assets/mbl.png";
import location from "../../../Assets/location_img.png";
import {
  base64DownloadService,
  billPdfService,
  viewBillListService,
} from "../../../Services/ApiServices";
import { base64ToBlob, parseBase64Response } from "../../../Utility/Utility";
import Loader from "../../../SharedComponents/Loader/Loader";
import paymentType from "../../../Assets/payment_type.png";
import downloadIcon from "../../../Assets/download.png";
import shareIcon from "../../../Assets/share.svg";
import moment from "moment";
import FileSaver from "file-saver";

export default function ViewBillList(props) {
  const [viewData, setViewData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [readmoreId, setReadmoreId] = useState([]);
  const [invoicePdfUrl, setInvoicePdfUrl] = useState("");
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfFileName, setPdfFileName] = useState("");

  useEffect(() => {
    handleViewList();
    if (props.isShowDownload && props.id) {
      base64DownloadService(1, props.id)
        .then((res) => {
          const { base64, fileName: sFileName, contentType: cType, url } =
            parseBase64Response(res);
          if (base64) {
            const blob = base64ToBlob(base64, cType);
            if (blob) setPdfBlob(blob);
          }
          if (sFileName) {
            const cleanName = sFileName.toLowerCase().endsWith(".pdf")
              ? sFileName
              : `${sFileName}.pdf`;
            setPdfFileName(cleanName);
          }
          if (url) setInvoicePdfUrl(url);
        })
        .catch((e) => {
          console.warn("Could not pre-fetch base64 PDF:", e);
        });
    }
  }, []);

  const handleViewList = () => {
    setIsLoader(true);
    viewBillListService(props.id)
      .then((res) => {
        setViewData(res.data);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleDownload = () => {
    setIsLoader(true);
    billPdfService(props.id)
      .then((res) => {
        let url = res.data.billing_url;
        let urlArr = url.split(".");
        let ext = urlArr[urlArr.length - 1];
        let dateTime =
          moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
        let fileName = dateTime + "." + ext;
        FileSaver.saveAs(url, fileName);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong test!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleShare = async () => {
    const billId = props.id || viewData?.id;
    const billNo = viewData?.bill_no || "";
    const customerName = viewData?.customer_name || "";
    const shareTitle = billNo ? `Invoice #${billNo}` : "Invoice";
    const shareText = `Invoice #${billNo}${customerName ? ` for ${customerName}` : ""}`;
    let fileName =
      pdfFileName || `${billNo ? `Invoice_${billNo}` : "Invoice"}.pdf`;

    let currentBlob = pdfBlob;
    let url = invoicePdfUrl;

    if (!currentBlob) {
      setIsLoader(true);
      try {
        const res = await base64DownloadService(1, billId);
        const {
          base64,
          fileName: sFileName,
          contentType: cType,
          url: resUrl,
        } = parseBase64Response(res);
        if (sFileName) {
          fileName = sFileName.toLowerCase().endsWith(".pdf")
            ? sFileName
            : `${sFileName}.pdf`;
          setPdfFileName(fileName);
        }
        if (resUrl) {
          url = resUrl;
          setInvoicePdfUrl(resUrl);
        }
        if (base64) {
          currentBlob = base64ToBlob(base64, cType);
          setPdfBlob(currentBlob);
        }
      } catch (err) {
        console.warn("Base64 invoice download failed, trying fallback:", err);
      }
      setIsLoader(false);
    }

    // Fallback: if no blob and no url, fetch URL via billPdfService
    if (!currentBlob && !url && billId) {
      setIsLoader(true);
      try {
        const res = await billPdfService(billId);
        url = res?.data?.billing_url;
        if (url) setInvoicePdfUrl(url);
      } catch (err) {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Failed to load invoice PDF");
        }
        setIsLoader(false);
        return;
      }
      setIsLoader(false);
    }

    if (!url && !currentBlob) {
      toast.error("Invoice PDF not found!");
      return;
    }

    if (navigator.share) {
      // 1. Try sharing as a PDF file attachment first!
      if (currentBlob) {
        try {
          const file = new File([currentBlob], fileName, {
            type: "application/pdf",
          });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
              files: [file],
              title: shareTitle,
              text: shareText,
            });
            return;
          }
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.warn("File share failed, falling back to URL share:", err);
        }
      }

      // 2. Fallback: share as URL if file sharing is not supported by browser
      if (url) {
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: url,
          });
          return;
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.error("Native share error:", err);
          toast.error("Unable to open share prompt");
          return;
        }
      }
    } else {
      if (url && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        toast.success("Invoice link copied to clipboard!");
      } else {
        toast.error(
          "Sharing is only supported on mobile devices with HTTPS or a supported browser."
        );
      }
    }
  };

  const getAdditionalProductsList = () => {
    let additionalProductsList = [];
    if (Array.isArray(viewData?.additional_products)) {
      additionalProductsList = viewData.additional_products;
    } else if (typeof viewData?.additional_products === "string") {
      try {
        const parsed = JSON.parse(viewData.additional_products);
        if (Array.isArray(parsed)) {
          additionalProductsList = parsed;
        }
      } catch (e) {
        additionalProductsList = [];
      }
    }
    return additionalProductsList;
  };

  const handleTotalAmount = () => {
    const purchasedTotal = (viewData?.purchased_products || []).reduce(
      (prev, current) => prev + (Number(current?.total_price) || 0),
      0,
    );

    const additionalProductsList = getAdditionalProductsList();
    const additionalTotal = additionalProductsList.reduce((prev, current) => {
      const qty = Number(
        current?.product_quantity ?? current?.quantity ?? current?.qty ?? 1,
      );
      const price = Number(current?.price || 0);
      const total =
        current?.total_price !== undefined && current?.total_price !== null
          ? Number(current.total_price)
          : qty * price;
      return prev + (isNaN(total) ? 0 : total);
    }, 0);

    const deliveryCharge = Number(viewData?.delivery_charge || 0);

    return purchasedTotal + additionalTotal + deliveryCharge;
  };

  return (
    <div>
      <Loader isLoader={isLoader} />
      <Modal show={props.isShow} onHide={props.onHide} centered size="lg">
        <Modal.Body>
          <div className={Styles.cancelImgParentContainer}>
            <div>
              <p className="fontBold">
                Bill <span className="orange">Details</span>
              </p>
            </div>
            <div className={Styles.iconsRow}>
              {props.isShowDownload ? (
                <>
                  <div
                    className={Styles.cancelImgContainer}
                    title="Download Invoice"
                    onClick={handleDownload}
                  >
                    <img
                      src={downloadIcon}
                      alt="Download"
                      className={Styles.cancelImg}
                    />
                  </div>
                  <div
                    className={Styles.cancelImgContainer}
                    title="Share Invoice"
                    onClick={handleShare}
                  >
                    <img
                      src={shareIcon}
                      alt="Share"
                      className={Styles.shareImg}
                    />
                  </div>
                </>
              ) : null}
              <div
                className={Styles.cancelImgContainer}
                title="Close"
                onClick={props.onHide}
              >
                <img
                  src={cancelIcon}
                  alt="cancel"
                  className={Styles.cancelImg}
                />
              </div>
            </div>
          </div>
          <div>
            <div className={Styles.detailUserContainer}>
              <div className={Styles.userLeftContainer}>
                <img className={Styles.img} src={Profile} alt="profile" />
                <p className={Styles.username}>{viewData?.customer_name}</p>
              </div>
              <div className={Styles.userRightContainer}>
                <p className={Styles.username + " text-start"}>
                  Invoice No :
                  <span className={Styles.detail}>{viewData?.bill_no}</span>
                </p>
              </div>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={phone} alt="profile" />
              <p className={Styles.detail}>{viewData?.mobile_no}</p>
            </div>
            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={mail} alt="profile" />
              <p className={Styles.detail}>
                {viewData?.email ? viewData?.email : "-"}
              </p>
            </div>
            <div className={Styles.detailContainer}>
              <img
                style={{ marginTop: "3px", alignSelf: "flex-start" }}
                className={Styles.location}
                src={location}
                alt="profile"
              />
              <p className={Styles.detail}>
                {viewData?.address}
                {","}
                <br />
                {viewData?.city_name}
                {","}
                <br />
                {viewData?.state_name}
                {viewData?.pincode ? (
                  <>
                    {" "}
                    {","}
                    <br />
                    {viewData?.pincode || ""}
                    {"."}
                  </>
                ) : (
                  "."
                )}
              </p>
            </div>
            <div className={Styles.detailUserContainer}>
              <div className={Styles.userLeftContainer}>
                <img className={Styles.img} src={paymentType} alt="profile" />
                <p className={Styles.username}>
                  {" "}
                  {viewData?.payment_type ? viewData?.payment_type : "-"}
                  <span style={{ fontWeight: 500 }}>
                    {viewData?.pos_number ? " - " + viewData?.pos_number : ""}
                  </span>
                </p>
              </div>
              <div className={Styles.userRightContainer}>
                <p className={Styles.username + " text-start"}>
                  Bill Status :
                  <span className={Styles.detail + " orange"}>
                    {viewData?.bill_status_type}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* Unified Products Table for Perfect Column Alignment */}
          {(viewData?.purchased_products?.length > 0 ||
            getAdditionalProductsList().length > 0) ? (
            <div className={Styles.tableParentContainer}>
              <div className={Styles.tableChildContainer + " mt-3"}>
                <table>
                  <thead>
                    <tr>
                      <th className=" label text-center">S.No</th>
                      <th
                        className={
                          Styles.productname + " label text-center"
                        }
                      >
                        Product Name
                      </th>
                      <th className={Styles.th + " label text-center"}>
                        {viewData?.purchased_products?.length > 0
                          ? "Color"
                          : "Brand"}
                      </th>
                      <th className={Styles.th + " label text-center"}>
                        Unit
                      </th>
                      <th className={Styles.th + " label text-center"}>
                        Qty
                      </th>
                      <th className=" label text-center">Price</th>
                      <th className=" label text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody className={Styles.data}>
                    {/* 1. Purchased Products Rows */}
                    {viewData?.purchased_products?.map((e, index) => (
                      <tr key={e.customer_bill_id || e.product_id || index}>
                        <td className="text-center">{index + 1}</td>
                        <td
                          className={
                            Styles.productname + " contentFont text-center"
                          }
                        >
                          {readmoreId.includes(e.product_id)
                            ? e.product_name
                            : e.product_name?.substring(0, 37)}
                          {e.product_name?.length > 37 &&
                            !readmoreId.includes(e.product_id)
                            ? "..."
                            : null}
                          <span
                            style={{
                              display:
                                (e.product_name?.length || 0) < 37
                                  ? "none"
                                  : "block",
                            }}
                            className={Styles.readmore + " orange"}
                            onClick={() => {
                              if (readmoreId.includes(e.product_id)) {
                                let filterData = readmoreId.filter(
                                  (filterId) => filterId !== e.product_id,
                                );
                                setReadmoreId(filterData);
                              } else {
                                setReadmoreId([...readmoreId, e.product_id]);
                              }
                            }}
                          >
                            {readmoreId.includes(e.product_id)
                              ? "Show Less"
                              : "Read More"}
                          </span>
                        </td>
                        <td className={Styles.td}>{e?.color_name || "-"}</td>
                        <td className={Styles.td}>
                          {e?.product_unit?.unit_name ||
                            (typeof e?.product_unit === "string"
                              ? e?.product_unit
                              : "-")}
                        </td>
                        <td className={Styles.td}>{e?.quantity}</td>
                        <td className={Styles.td}>
                          {"₹ " +
                            (e?.price !== undefined && e?.price !== null
                              ? Number(e.price).toFixed(2)
                              : "0.00")}
                        </td>
                        <td className={Styles.td}>
                          {"₹ " +
                            (e?.total_price !== undefined &&
                              e?.total_price !== null
                              ? Number(e.total_price).toFixed(2)
                              : "0.00")}
                        </td>
                      </tr>
                    ))}

                    {/* 2. Additional Products Section (Inside same table for exact alignment) */}
                    {getAdditionalProductsList().length > 0 && (
                      <>
                        <tr>
                          <td
                            colSpan={7}
                            style={{
                              padding: "16px 0 6px 0",
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          >
                            <p
                              className="m-0"
                              style={{
                                fontSize: "13px",
                                fontWeight: 600,
                                color: "#6c757d",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              Additional Products
                            </p>
                          </td>
                        </tr>
                        <tr style={{ background: "#f77a26", color: "#fff" }}>
                          <th className=" label text-center">S.No</th>
                          <th
                            className={
                              Styles.productname + " label text-center"
                            }
                          >
                            Product Name
                          </th>
                          <th className={Styles.th + " label text-center"}>
                            Brand
                          </th>
                          <th className={Styles.th + " label text-center"}>
                            Unit
                          </th>
                          <th className={Styles.th + " label text-center"}>
                            Qty
                          </th>
                          <th className=" label text-center">Price</th>
                          <th className=" label text-center">Total</th>
                        </tr>
                        {getAdditionalProductsList().map((e, index) => {
                          const manualKey = `manual_${index}_${e?.product_name}`;
                          const productName =
                            e?.product_name || e?.name || "-";
                          const brandName = e?.brand_name || e?.brand || "-";
                          const unit =
                            e?.product_unit || e?.unit || e?.unit_name || "-";
                          const qty = Number(
                            e?.product_quantity ?? e?.quantity ?? e?.qty ?? 1,
                          );
                          const price =
                            e?.price !== undefined && e?.price !== null
                              ? Number(e.price)
                              : 0;
                          const totalPrice =
                            e?.total_price !== undefined &&
                              e?.total_price !== null
                              ? Number(e.total_price)
                              : qty * price;

                          return (
                            <tr key={manualKey}>
                              <td className="text-center">{index + 1}</td>
                              <td
                                className={
                                  Styles.productname +
                                  " contentFont text-center"
                                }
                              >
                                {readmoreId.includes(manualKey)
                                  ? productName
                                  : productName.substring(0, 37)}
                                {productName.length > 37 &&
                                  !readmoreId.includes(manualKey)
                                  ? "..."
                                  : null}

                                {productName.length > 37 && (
                                  <span
                                    className={Styles.readmore + " orange"}
                                    onClick={() =>
                                      setReadmoreId((prev) =>
                                        prev.includes(manualKey)
                                          ? prev.filter(
                                            (id) => id !== manualKey,
                                          )
                                          : [...prev, manualKey],
                                      )
                                    }
                                  >
                                    {readmoreId.includes(manualKey)
                                      ? "Show Less"
                                      : "Read More"}
                                  </span>
                                )}
                              </td>
                              <td className={Styles.td}>{brandName}</td>
                              <td className={Styles.td}>{unit}</td>
                              <td className={Styles.td}>{qty}</td>
                              <td className={Styles.td}>
                                {"₹ " + price.toFixed(2)}
                              </td>
                              <td className={Styles.td}>
                                {"₹ " + totalPrice.toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    )}

                    {/* 3. Delivery Charge and Total at the bottom */}
                    <tr>
                      <td colSpan={5} />
                      <td className={Styles.td + " fw-bold"}>
                        Delivery Charge
                      </td>
                      <td className={Styles.td + " fw-bold"}>
                        {"₹ " +
                          (viewData?.delivery_charge !== undefined &&
                            viewData?.delivery_charge !== null
                            ? Number(viewData.delivery_charge).toFixed(2)
                            : "0.00")}
                      </td>
                    </tr>
                      <tr>
                        <td colSpan={5} />
                        <td
                          className={Styles.td + " fw-bold orange"}
                          style={{
                            fontSize: "15px",
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                          }}
                        >
                          TOTAL
                        </td>
                        <td
                          className={Styles.td + " fw-bold orange"}
                          style={{
                            fontSize: "16px",
                            fontWeight: 700,
                          }}
                        >
                          ₹ {handleTotalAmount().toFixed(2)}
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
}


